import React from 'react';
import { Button } from '@material-ui/core';

export default function BackButton({ handleBack, width = '175px', height = '42px' }) {
  return (
    <Button
      variant="contained"
      style={{
        width,
        height,
        marginLeft: '20px',
        fontFamily: 'Montserrat',
        fontStyle: 'normal',
        fontWeight: '600',
        fontSize: '14px',
        lineHeight: '17px',
        textAlign: 'center',
      }}
      onClick={handleBack}
    >
      Back
    </Button>
  );
}
